//Slider logic
var galleryThumbs = new Swiper(".hoox-shop__gallery-thumbs", {
  slidesPerView: 4,
  spaceBetween: 8,
  loop: false,
  watchSlidesProgress: true,
  breakpoints: {
    768: {
      spaceBetween: 16,
      direction: "vertical",
      slidesPerView: 6,
    },
  },
});

var galleryTop = new Swiper(".hoox-shop__gallery-main", {
  slidesPerView: 1,
  loop: true,
  thumbs: {
    swiper: galleryThumbs,
  },
});

const modalHolders = document.querySelectorAll(".hoox-shop__popup-holder");
if (!!modalHolders.length) {
  modalHolders.forEach((element) => {
    // Toggle popup modal logic for multiple trigger classes
    const modalTriggers = element.querySelectorAll(".js-popup-modal-trigger");
    const popupModal = element.querySelector(".hoox-shop__popup-modal");

    modalTriggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        popupModal.classList.toggle("open-modal");
        element.classList.toggle("active");
      });
    });
  });
}

const tabsShop = document.querySelectorAll(".hoox-shop__tab");
tabsShop.forEach((tab) => {
  tab.addEventListener("click", () => {
    setActive(tab);
  });
});

const showShopPanels = (tab) => {
  tab.addEventListener("click", () => {
    let tabIndex = tab.getAttribute("data-shop-tab");
    let panels = document.querySelectorAll(".hoox-shop__panel");

    panels.forEach((panel) => {
      const panelIndex = panel.getAttribute("data-shop-panel");
      if (panelIndex === tabIndex) {
        setActive(panel);
      }
    });
  });
};

const setActive = function (el) {
  [...el.parentElement.children].forEach(function (sib) {
    sib.classList.remove("active");
  });
  el.classList.add("active");
};

tabsShop.forEach((tab) => {
  showShopPanels(tab);
});

const shopTabsContent = document.querySelectorAll(".hoox-shop__panel");

shopTabsContent.forEach((panel, panelIndex) => {
  const pdpUls = panel.querySelectorAll("ul");
  
  pdpUls.forEach((ul, ulIndex) => {
    const panellistItems = ul.querySelectorAll("li");
    
    panellistItems.forEach((li, liIndex) => {
      const checkmarkSvg = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2510_2370)">
      <path d="M10 0C4.48578 0 0 4.48578 0 10C0 15.5142 4.48578 20 10 20C15.5142 20 20 15.5142 20 10C20 4.48578 15.5142 0 10 0Z" fill="#452A6C"/>
      <path d="M15.0682 7.88074L9.65152 13.2973C9.48901 13.4598 9.2757 13.5416 9.06238 13.5416C8.84906 13.5416 8.63574 13.4598 8.47324 13.2973L5.76495 10.589C5.43903 10.2632 5.43903 9.73651 5.76495 9.41074C6.09073 9.08481 6.61731 9.08481 6.94324 9.41074L9.06238 11.5299L13.89 6.70245C14.2157 6.37653 14.7423 6.37653 15.0682 6.70245C15.394 7.02823 15.394 7.55481 15.0682 7.88074Z" fill="white"/>
      </g>
      <defs>
      <clipPath id="clip0_2510_2370">
      <rect width="20" height="20" fill="white"/>
      </clipPath>
      </defs>
      </svg>
      `;

      const checkmark = document.createElement("div");
      checkmark.innerHTML = checkmarkSvg;
      
      li.prepend(checkmark);

      // Check if it's the last <ul> in the last .hoox-shop__panel and the last <li> in that <ul>
      if (panelIndex === shopTabsContent.length - 1 && ulIndex === pdpUls.length - 1 && liIndex === panellistItems.length - 1) {
        const differentSvg = `<img style="max-width: 48px;" src="https://cdn.shopify.com/s/files/1/0418/3035/1012/files/image_2_02479640-4f5d-40ef-bf02-08c5bc71369d.png?v=1711537458">`;

        const differentCheckmark = document.createElement("div");
        differentCheckmark.innerHTML = differentSvg;

        // Replace the first SVG with the second one in the last <li>
        li.replaceChild(differentCheckmark, li.firstChild);
      }
      if (panelIndex === shopTabsContent.length - 1 && ulIndex === pdpUls.length - 1 && liIndex === panellistItems.length - 2) {
        const differentSvg = `<img style="max-width: 48px;" src="https://cdn.shopify.com/s/files/1/0418/3035/1012/files/image_3_16fab11f-4b3a-40bd-b543-a9db4e93d2fc.png?v=1711537457">`;

        const differentCheckmark = document.createElement("div");
        differentCheckmark.innerHTML = differentSvg;

        // Replace the first SVG with the second one in the last <li>
        li.replaceChild(differentCheckmark, li.firstChild);
      }
    });
  });
});








